var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 90 90",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20h70v5H10zM10 40h70v5H10z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e94256",
    d: "M45 60h35v5H45z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTAgOTAiIHdpZHRoPSIxZW0iIGhlaWdodD0iMWVtIj4KICAgIDxyZWN0IHk9IjIwIiB4PSIxMCIgd2lkdGg9IjcwIiBoZWlnaHQ9IjUiPjwvcmVjdD4KICAgIDxyZWN0IHk9IjQwIiB4PSIxMCIgd2lkdGg9IjcwIiBoZWlnaHQ9IjUiPjwvcmVjdD4KICAgIDxyZWN0IHk9IjYwIiB4PSI0NSIgd2lkdGg9IjM1IiBoZWlnaHQ9IjUiIGZpbGw9IiNlOTQyNTYiPjwvcmVjdD4KPC9zdmc+";
export { SvgHamburger as ReactComponent };